import { message } from 'antd';
/**
 * 检查图片上传之前的格式检查
 */

function checkImageWH(file, width, height) {
  return new Promise(function (resolve, reject) {
    const filereader = new FileReader();
    filereader.onload = (e) => {
      const src = e.target.result;
      const image = new Image();
      image.onload = function () {
        if (width && this.width !== width) {
          message.error('上传图片的宽不符合要求，请重传!');
          return reject(new Error('上传图片的宽不符合要求，请重传!'));
        } else if (height && this.height !== height) {
          message.error('上传图片的高不符合要求，请重传!');
          return reject(new Error('上传图片的高不符合要求，请重传!'));
        } else {
          return resolve();
        }
      };
      image.onerror = reject;
      image.src = src;
    };
    filereader.readAsDataURL(file);
  });
}
export function beforePicUpload(file, width, size, height) {
  return new Promise(function (resolve, reject) {
    const isJpgOrPng =
      file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/gif';
    if (!isJpgOrPng) {
      message.error('只支持上传JPG/PNG/JPEG/GIF文件!');
      return reject(new Error('只支持上传JPG/PNG/JPEG/GIF文件!'));
    } else {
      const isSizeOut = size ? file.size / 1024 > +size : false;
      if (isSizeOut) {
        message.error(`上传图片需小于${size}Kb!`);
        return reject(new Error(`上传图片需小于${size}Kb!`));
      } else {
        checkImageWH(file, width, height)
          .then(() => {
            return resolve();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  });
}
